import { Link } from 'gatsby';
import React from 'react';
import { Crumb } from '../../app/breadCrumbs/BreadcrumbHandler';
import { SectionContainer } from './sections/SectionContainer';

type Props = {
  crumbs: Array<Crumb>;
  width: string;
  containerClass?: string;
  bkgColor?: string;
  allowBlank?: boolean;
};

/**
 * Breadcrumb
 * @return {JSX}
 */
export default function Breadcrumb({
  crumbs = [],
  width,
  bkgColor = 'bg-white',
  containerClass = 'py-2 h-9',
  allowBlank = false
}: Props) {
  if (crumbs.length <= 1 && !allowBlank) {
    return null;
  }

  return (
    <SectionContainer bkgColor={bkgColor} width="full" disableIndent={true}>
      <SectionContainer
        containerClass={containerClass}
        width={width}
        disableSuppression={true}
        disableIndent={true}
      >
        <nav className="relative flex space-x-2 text-sm overflow-y-hidden overflow-x-auto touch-pan-x no-scrollbar">
          {crumbs.length > 1 &&
            crumbs.map((crumb, i) => {
              const chev = i > 0 ? <div className="pr-2">&gt;</div> : null;
              if (i < crumbs.length - 1) {
                return (
                  <div className="inline-flex whitespace-nowrap" key={`crumb-${i}`}>
                    {chev}
                    <div className="text-left font-normal text-black link">
                      <Link to={crumb.path}>{crumb.label}</Link>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div className="inline-flex whitespace-nowrap" key={`crumb-${i}`}>
                    {chev}
                    <div className="text-left font-normal text-gray-700">{crumb.label}</div>
                  </div>
                );
              }
            })}
        </nav>
        <div
          className={`absolute top-0 right-0 h-full w-10 bg-gradient-to-r from-transparent ${
            bkgColor.indexOf('gray') > -1 ? 'to-gray-50' : 'to-white'
          }`}
        ></div>
      </SectionContainer>
    </SectionContainer>
  );
}
